"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionIcon = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var tooltipV2_1 = require("../tooltipV2");
var styles_1 = require("./styles");
var ActionIcon = function (_a) {
    var id = _a.id, className = _a.className, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, icon = _a.icon, disabled = _a.disabled, onClick = _a.onClick, tooltipLabel = _a.tooltipLabel, _b = _a.tooltipPosition, tooltipPosition = _b === void 0 ? 'left' : _b, ariaLabel = _a.ariaLabel, marginIcon = _a.marginIcon, dataTestId = _a.dataTestId, props = __rest(_a, ["id", "className", "gaCategory", "gaAction", "gaLabel", "gaEventType", "icon", "disabled", "onClick", "tooltipLabel", "tooltipPosition", "ariaLabel", "marginIcon", "dataTestId"]);
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (react_1.default.createElement(styles_1.ActionIconSectionStyled, __assign({ className: className, style: { margin: marginIcon } }, props),
        react_1.default.createElement(tooltipV2_1.TooltipV2Card, { left: tooltipPosition === 'left', right: tooltipPosition === 'right' },
            react_1.default.createElement(tooltipV2_1.TooltipV2Content, null,
                react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
                    react_1.default.createElement(styles_1.ActionIconButtonStyled, { "data-testid": dataTestId, id: id, onClick: onClick, disabled: disabled, "aria-label": ariaLabel }, icon))),
            tooltipLabel && (react_1.default.createElement(tooltipV2_1.TooltipV2Box, { left: tooltipPosition === 'left', right: tooltipPosition === 'right' },
                react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, color: theme.white }, tooltipLabel))))));
};
exports.ActionIcon = ActionIcon;
